module.exports = __webpack_public_path__ + "839a1f1b01ff467b234464272a36303b.png";